import type { Language } from "./types"

/** route segments */
export const ROUTE_SEGMENTS = {
    main: 'main',
    search: 'search',
    checkout: 'checkout',
    myReservations: 'my-reservations',
    profile: 'profile',
    success: 'success',
    garage: 'garage',
}

export const RETURN_IN_HISTORY_PARAM_KEY = 'return-in-history'

//
// Source: https://github.com/michaelwittig/node-i18n-iso-countries/ ... npm package i18n-iso-countries
//
export const COUNTRIES: {
    [languageIso in Language]: {
        [countryIso: string]: string | string[]
    }
} = {
    cs: {
        AF: 'Afghánistán',
        AX: 'Ålandy',
        AL: 'Albánie',
        DZ: 'Alžírsko',
        AS: 'Americká Samoa',
        VI: 'Americké Panenské ostrovy',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarktida',
        AG: 'Antigua a Barbuda',
        AR: 'Argentina',
        AM: 'Arménie',
        AW: 'Aruba',
        AU: 'Austrálie',
        AZ: 'Ázerbájdžán',
        BS: 'Bahamy',
        BH: 'Bahrajn',
        BD: 'Bangladéš',
        BB: 'Barbados',
        BE: 'Belgie',
        BZ: 'Belize',
        BY: 'Bělorusko',
        BJ: 'Benin',
        BM: 'Bermudy',
        BT: 'Bhútán',
        BO: 'Bolívie',
        BQ: 'Bonaire, Svatý Eustach a Saba',
        BA: 'Bosna a Hercegovina',
        BW: 'Botswana',
        BV: 'Bouvetův ostrov',
        BR: 'Brazílie',
        IO: 'Britské indickooceánské území',
        VG: 'Britské Panenské ostrovy',
        BN: 'Brunej',
        BG: 'Bulharsko',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        CK: 'Cookovy ostrovy',
        CW: 'Curaçao',
        TD: 'Čad',
        ME: 'Černá Hora',
        CZ: 'Česká republika',
        CN: 'Čína',
        DK: 'Dánsko',
        CD: 'Demokratická republika Kongo',
        DM: 'Dominika',
        DO: 'Dominikánská republika',
        DJ: 'Džibutsko',
        EG: 'Egypt',
        EC: 'Ekvádor',
        ER: 'Eritrea',
        EE: 'Estonsko',
        ET: 'Etiopie',
        FO: 'Faerské ostrovy',
        FK: 'Falklandy (Malvíny)',
        FJ: 'Fidži',
        PH: 'Filipíny',
        FI: 'Finsko',
        FR: 'Francie',
        GF: 'Francouzská Guyana',
        TF: 'Francouzská jižní a antarktická území',
        PF: 'Francouzská Polynésie',
        GA: 'Gabon',
        GM: 'Gambie',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GL: 'Grónsko',
        GE: 'Gruzie',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GG: 'Guernsey',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heardův ostrov a McDonaldovy ostrovy',
        HN: 'Honduras',
        HK: 'Hongkong',
        CL: 'Chile',
        HR: 'Chorvatsko',
        IN: 'Indie',
        ID: 'Indonésie',
        IQ: 'Irák',
        IR: 'Írán',
        IE: 'Irsko',
        IS: 'Island',
        IT: 'Itálie',
        IL: 'Izrael',
        JM: 'Jamajka',
        JP: 'Japonsko',
        YE: 'Jemen',
        JE: 'Jersey',
        ZA: 'Jihoafrická republika',
        GS: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
        KR: 'Jižní Korea',
        SS: 'Jižní Súdán',
        JO: 'Jordánsko',
        KY: 'Kajmanské ostrovy',
        KH: 'Kambodža',
        CM: 'Kamerun',
        CA: 'Kanada',
        CV: 'Kapverdy',
        QA: 'Katar',
        KZ: 'Kazachstán',
        KE: 'Keňa',
        KI: 'Kiribati',
        CC: 'Kokosové ostrovy',
        CO: 'Kolumbie',
        KM: 'Komory',
        CG: 'Kongo',
        CR: 'Kostarika',
        CU: 'Kuba',
        KW: 'Kuvajt',
        CY: 'Kypr',
        KG: 'Kyrgyzstán',
        LA: 'Laos',
        LS: 'Lesotho',
        LB: 'Libanon',
        LR: 'Libérie',
        LY: 'Libye',
        LI: 'Lichtenštejnsko',
        LT: 'Litva',
        LV: 'Lotyšsko',
        LU: 'Lucembursko',
        MO: 'Macao',
        MG: 'Madagaskar',
        HU: 'Maďarsko',
        MY: 'Malajsie',
        MW: 'Malawi',
        MV: 'Maledivy',
        ML: 'Mali',
        MT: 'Malta',
        IM: 'Ostrov Man',
        MA: 'Maroko',
        MH: 'Marshallovy ostrovy',
        MQ: 'Martinik',
        MU: 'Mauricius',
        MR: 'Mauritánie',
        YT: 'Mayotte',
        UM: 'Menší odlehlé ostrovy USA',
        MX: 'Mexiko',
        FM: 'Mikronésie',
        MD: 'Moldavsko',
        MC: 'Monako',
        MN: 'Mongolsko',
        MS: 'Montserrat',
        MZ: 'Mosambik',
        MM: 'Myanmar',
        NA: 'Namibie',
        NR: 'Nauru',
        DE: 'Německo',
        NP: 'Nepál',
        NE: 'Niger',
        NG: 'Nigérie',
        NI: 'Nikaragua',
        NU: 'Niue',
        NL: 'Nizozemsko',
        NF: 'Norfolk',
        NO: 'Norsko',
        NC: 'Nová Kaledonie',
        NZ: 'Nový Zéland',
        OM: 'Omán',
        PK: 'Pákistán',
        PW: 'Palau',
        PS: 'Palestinská autonomie',
        PA: 'Panama',
        PG: 'Papua-Nová Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PN: 'Pitcairnovy ostrovy',
        CI: 'Pobřeží slonoviny',
        PL: 'Polsko',
        PR: 'Portoriko',
        PT: 'Portugalsko',
        AT: 'Rakousko',
        RE: 'Réunion',
        GQ: 'Rovníková Guinea',
        RO: 'Rumunsko',
        RU: 'Rusko',
        RW: 'Rwanda',
        GR: 'Řecko',
        PM: 'Saint-Pierre a Miquelon',
        SV: 'Salvador',
        WS: 'Samoa',
        SM: 'San Marino',
        SA: 'Saúdská Arábie',
        SN: 'Senegal',
        KP: 'Severní Korea',
        MK: 'Severní Makedonie',
        MP: 'Severní Mariany',
        SC: 'Seychely',
        SL: 'Sierra Leone',
        SG: 'Singapur',
        SK: 'Slovensko',
        SI: 'Slovinsko',
        SO: 'Somálsko',
        AE: 'Spojené arabské emiráty',
        GB: 'Spojené království',
        US: 'Spojené státy americké',
        RS: 'Srbsko',
        CF: 'Středoafrická republika',
        SD: 'Súdán',
        SR: 'Surinam',
        SH: 'Svatá Helena, Ascension a Tristan da Cunha',
        LC: 'Svatá Lucie',
        BL: 'Svatý Bartoloměj',
        KN: 'Svatý Kryštof a Nevis',
        MF: 'Svatý Martin (francouzská část)',
        SX: 'Svatý Martin (nizozemská část)',
        ST: 'Svatý Tomáš a Princův ostrov',
        VC: 'Svatý Vincenc a Grenadiny',
        SZ: 'Svazijsko',
        SY: 'Sýrie',
        SB: 'Šalamounovy ostrovy',
        ES: 'Španělsko',
        SJ: 'Špicberky a Jan Mayen',
        LK: 'Šrí Lanka',
        SE: 'Švédsko',
        CH: 'Švýcarsko',
        TJ: 'Tádžikistán',
        TZ: 'Tanzanie',
        TH: 'Thajsko',
        TW: 'Tchaj-wan',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad a Tobago',
        TN: 'Tunisko',
        TR: 'Turecko',
        TM: 'Turkmenistán',
        TC: 'Turks a Caicos',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukrajina',
        UY: 'Uruguay',
        UZ: 'Uzbekistán',
        CX: 'Vánoční ostrov',
        VU: 'Vanuatu',
        VA: 'Vatikán',
        VE: 'Venezuela',
        VN: 'Vietnam',
        TL: 'Východní Timor',
        WF: 'Wallis a Futuna',
        ZM: 'Zambie',
        EH: 'Západní Sahara',
        ZW: 'Zimbabwe',
        XK: 'Kosovo',
    },
    pl: {
        AF: 'Afganistan',
        AL: 'Albania',
        DZ: 'Algieria',
        AS: 'Samoa Amerykańskie',
        AD: 'Andora',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarktyka',
        AG: 'Antigua i Barbuda',
        AR: 'Argentyna',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbejdżan',
        BS: 'Bahamy',
        BH: 'Bahrajn',
        BD: 'Bangladesz',
        BB: 'Barbados',
        BY: 'Białoruś',
        BE: 'Belgia',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermudy',
        BT: 'Bhutan',
        BO: 'Boliwia',
        BA: 'Bośnia i Hercegowina',
        BW: 'Botswana',
        BV: 'Wyspa Bouveta',
        BR: 'Brazylia',
        IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
        BN: 'Brunei',
        BG: 'Bułgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Kambodża',
        CM: 'Kamerun',
        CA: 'Kanada',
        CV: 'Republika Zielonego Przylądka',
        KY: 'Kajmany',
        CF: 'Republika Środkowoafrykańska',
        TD: 'Czad',
        CL: 'Chile',
        CN: 'Chiny',
        CX: 'Wyspa Bożego Narodzenia',
        CC: 'Wyspy Kokosowe',
        CO: 'Kolumbia',
        KM: 'Komory',
        CG: 'Kongo',
        CD: 'Demokratyczna Republika Konga',
        CK: 'Wyspy Cooka',
        CR: 'Kostaryka',
        CI: 'Wybrzeże Kości Słoniowej',
        HR: 'Chorwacja',
        CU: 'Kuba',
        CY: 'Cypr',
        CZ: 'Czechy',
        DK: 'Dania',
        DJ: 'Dżibuti',
        DM: 'Dominika',
        DO: 'Dominikana',
        EC: 'Ekwador',
        EG: 'Egipt',
        SV: 'Salwador',
        GQ: 'Gwinea Równikowa',
        ER: 'Erytrea',
        EE: 'Estonia',
        ET: 'Etiopia',
        FK: 'Falklandy',
        FO: 'Wyspy Owcze',
        FJ: 'Fidżi',
        FI: 'Finlandia',
        FR: 'Francja',
        GF: 'Gujana Francuska',
        PF: 'Polinezja Francuska',
        TF: 'Francuskie Terytoria Południowe i Antarktyczne',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Gruzja',
        DE: 'Niemcy',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Grecja',
        GL: 'Grenlandia',
        GD: 'Grenada',
        GP: 'Gwadelupa',
        GU: 'Guam',
        GT: 'Gwatemala',
        GN: 'Gwinea',
        GW: 'Gwinea Bissau',
        GY: 'Gujana',
        HT: 'Haiti',
        HM: 'Wyspy Heard i McDonalda',
        VA: 'Watykan',
        HN: 'Honduras',
        HK: 'Hongkong',
        HU: 'Węgry',
        IS: 'Islandia',
        IN: 'Indie',
        ID: 'Indonezja',
        IR: 'Iran',
        IQ: 'Irak',
        IE: 'Irlandia',
        IL: 'Izrael',
        IT: 'Włochy',
        JM: 'Jamajka',
        JP: 'Japonia',
        JO: 'Jordania',
        KZ: 'Kazachstan',
        KE: 'Kenia',
        KI: 'Kiribati',
        KP: 'Korea Północna',
        KR: 'Korea Południowa',
        KW: 'Kuwejt',
        KG: 'Kirgistan',
        LA: 'Laos',
        LV: 'Łotwa',
        LB: 'Liban',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libia',
        LI: 'Liechtenstein',
        LT: 'Litwa',
        LU: 'Luksemburg',
        MO: 'Makau',
        MK: 'Macedonia Północna',
        MG: 'Madagaskar',
        MW: 'Malawi',
        MY: 'Malezja',
        MV: 'Malediwy',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Wyspy Marshalla',
        MQ: 'Martynika',
        MR: 'Mauretania',
        MU: 'Mauritius',
        YT: 'Majotta',
        MX: 'Meksyk',
        FM: 'Mikronezja',
        MD: 'Mołdawia',
        MC: 'Monako',
        MN: 'Mongolia',
        MS: 'Montserrat',
        MA: 'Maroko',
        MZ: 'Mozambik',
        MM: 'Mjanma',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NL: 'Holandia',
        NC: 'Nowa Kaledonia',
        NZ: 'Nowa Zelandia',
        NI: 'Nikaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk',
        MP: 'Mariany Północne',
        NO: 'Norwegia',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestyna',
        PA: 'Panama',
        PG: 'Papua-Nowa Gwinea',
        PY: 'Paragwaj',
        PE: 'Peru',
        PH: 'Filipiny',
        PN: 'Pitcairn',
        PL: 'Polska',
        PT: 'Portugalia',
        PR: 'Portoryko',
        QA: 'Katar',
        RE: 'Reunion',
        RO: 'Rumunia',
        RU: 'Rosja',
        RW: 'Rwanda',
        SH: 'Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha',
        KN: 'Saint Kitts i Nevis',
        LC: 'Saint Lucia',
        PM: 'Saint-Pierre i Miquelon',
        VC: 'Saint Vincent i Grenadyny',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Wyspy Świętego Tomasza i Książęca',
        SA: 'Arabia Saudyjska',
        SN: 'Senegal',
        SC: 'Seszele',
        SL: 'Sierra Leone',
        SG: 'Singapur',
        SK: 'Słowacja',
        SI: 'Słowenia',
        SB: 'Wyspy Salomona',
        SO: 'Somalia',
        ZA: 'Południowa Afryka',
        GS: 'Georgia Południowa i Sandwich Południowy',
        ES: 'Hiszpania',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Surinam',
        SJ: 'Svalbard i Jan Mayen',
        SZ: 'Eswatini',
        SE: 'Szwecja',
        CH: 'Szwajcaria',
        SY: 'Syria',
        TW: 'Tajwan',
        TJ: 'Tadżykistan',
        TZ: 'Tanzania',
        TH: 'Tajlandia',
        TL: 'Timor Wschodni',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trynidad i Tobago',
        TN: 'Tunezja',
        TR: 'Turcja',
        TM: 'Turkmenistan',
        TC: 'Turks i Caicos',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraina',
        AE: 'Zjednoczone Emiraty Arabskie',
        GB: 'Wielka Brytania',
        US: 'Stany Zjednoczone',
        UM: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
        UY: 'Urugwaj',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Wenezuela',
        VN: 'Wietnam',
        VG: 'Brytyjskie Wyspy Dziewicze',
        VI: 'Wyspy Dziewicze Stanów Zjednoczonych',
        WF: 'Wallis i Futuna',
        EH: 'Sahara Zachodnia',
        YE: 'Jemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
        AX: 'Wyspy Alandzkie',
        BQ: 'Bonaire, Sint Eustatius i Saba',
        CW: 'Curaçao',
        GG: 'Guernsey',
        IM: 'Wyspa Man',
        JE: 'Jersey',
        ME: 'Czarnogóra',
        BL: 'Saint-Barthélemy',
        MF: 'Saint-Martin',
        RS: 'Serbia',
        SX: 'Sint Maarten',
        SS: 'Sudan Południowy',
        XK: 'Kosowo',
    },
    de: {
        AF: 'Afghanistan',
        EG: 'Ägypten',
        AX: 'Åland',
        AL: 'Albanien',
        DZ: 'Algerien',
        AS: 'Amerikanisch-Samoa',
        VI: 'Amerikanische Jungferninseln',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarktis',
        AG: 'Antigua und Barbuda',
        GQ: 'Äquatorialguinea',
        AR: 'Argentinien',
        AM: 'Armenien',
        AW: 'Aruba',
        AZ: 'Aserbaidschan',
        ET: 'Äthiopien',
        AU: 'Australien',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesch',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgien',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivien',
        BQ: 'Bonaire',
        BA: 'Bosnien und Herzegowina',
        BW: 'Botswana',
        BV: 'Bouvetinsel',
        BR: 'Brasilien',
        VG: 'Britische Jungferninseln',
        IO: 'Britisches Territorium im Indischen Ozean',
        BN: 'Brunei Darussalam',
        BG: 'Bulgarien',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        CL: 'Chile',
        CN: 'China',
        CK: 'Cookinseln',
        CR: 'Costa Rica',
        CI: 'Elfenbeinküste',
        CW: 'Curaçao',
        DK: 'Dänemark',
        DE: 'Deutschland',
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        DJ: 'Dschibuti',
        EC: 'Ecuador',
        SV: 'El Salvador',
        ER: 'Eritrea',
        EE: 'Estland',
        FK: 'Falklandinseln',
        FO: 'Färöer',
        FJ: 'Fidschi',
        FI: 'Finnland',
        FR: 'Frankreich',
        GF: 'Französisch-Guayana',
        PF: 'Französisch-Polynesien',
        TF: 'Französische Süd- und Antarktisgebiete',
        GA: 'Gabun',
        GM: 'Gambia',
        GE: 'Georgien',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GR: 'Griechenland',
        GL: 'Grönland',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard und McDonaldinseln',
        HN: 'Honduras',
        HK: ['Hongkong', 'Hong Kong'],
        IN: 'Indien',
        ID: 'Indonesien',
        IM: 'Insel Man',
        IQ: 'Irak',
        IR: 'Iran',
        IE: 'Irland',
        IS: 'Island',
        IL: 'Israel',
        IT: 'Italien',
        JM: 'Jamaika',
        JP: 'Japan',
        YE: 'Jemen',
        JE: 'Jersey',
        JO: 'Jordanien',
        KY: 'Kaimaninseln',
        KH: 'Kambodscha',
        CM: 'Kamerun',
        CA: 'Kanada',
        CV: 'Kap Verde',
        KZ: 'Kasachstan',
        QA: 'Katar',
        KE: 'Kenia',
        KG: 'Kirgisistan',
        KI: 'Kiribati',
        CC: 'Kokosinseln',
        CO: 'Kolumbien',
        KM: 'Komoren',
        CD: 'Kongo',
        KP: 'Nordkorea',
        KR: 'Südkorea',
        HR: 'Kroatien',
        CU: 'Kuba',
        KW: 'Kuwait',
        LA: 'Laos',
        LS: 'Lesotho',
        LV: 'Lettland',
        LB: 'Libanon',
        LR: 'Liberia',
        LY: 'Libyen',
        LI: 'Liechtenstein',
        LT: 'Litauen',
        LU: 'Luxemburg',
        MO: 'Macao',
        MG: 'Madagaskar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Malediven',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Marokko',
        MH: 'Marshallinseln',
        MQ: 'Martinique',
        MR: 'Mauretanien',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexiko',
        FM: 'Mikronesien',
        MD: 'Moldawien',
        MC: 'Monaco',
        MN: 'Mongolei',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mosambik',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NC: 'Neukaledonien',
        NZ: 'Neuseeland',
        NI: 'Nicaragua',
        NL: 'Niederlande',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        MK: 'Nordmazedonien',
        MP: 'Nördliche Marianen',
        NF: 'Norfolkinsel',
        NO: 'Norwegen',
        OM: 'Oman',
        AT: 'Österreich',
        TL: 'Osttimor',
        PK: 'Pakistan',
        PS: 'Staat Palästina',
        PW: 'Palau',
        PA: 'Panama',
        PG: 'Papua-Neuguinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippinen',
        PN: 'Pitcairninseln',
        PL: 'Polen',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        TW: 'Taiwan',
        CG: 'Republik Kongo',
        RE: 'Réunion',
        RW: 'Ruanda',
        RO: 'Rumänien',
        RU: ['Russische Föderation', 'Russland'],
        BL: 'Saint-Barthélemy',
        MF: 'Saint-Martin',
        SB: 'Salomonen',
        ZM: 'Sambia',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'São Tomé und Príncipe',
        SA: 'Saudi-Arabien',
        SE: 'Schweden',
        CH: 'Schweiz',
        SN: 'Senegal',
        RS: 'Serbien',
        SC: 'Seychellen',
        SL: 'Sierra Leone',
        ZW: 'Simbabwe',
        SG: 'Singapur',
        SX: 'Sint Maarten',
        SK: 'Slowakei',
        SI: 'Slowenien',
        SO: 'Somalia',
        ES: 'Spanien',
        LK: 'Sri Lanka',
        SH: 'St. Helena',
        KN: 'St. Kitts und Nevis',
        LC: 'St. Lucia',
        PM: 'Saint-Pierre und Miquelon',
        VC: 'St. Vincent und die Grenadinen',
        ZA: 'Südafrika',
        SD: 'Sudan',
        GS: 'Südgeorgien und die Südlichen Sandwichinseln',
        SS: 'Südsudan',
        SR: 'Suriname',
        SJ: 'Svalbard und Jan Mayen',
        SZ: 'Eswatini',
        SY: 'Syrien, Arabische Republik',
        TJ: 'Tadschikistan',
        TZ: ['Tansania, Vereinigte Republik', 'Tansania'],
        TH: 'Thailand',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad und Tobago',
        TD: 'Tschad',
        CZ: ['Tschechische Republik', 'Tschechien'],
        TN: 'Tunesien',
        TR: 'Türkei',
        TM: 'Turkmenistan',
        TC: 'Turks- und Caicosinseln',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        HU: 'Ungarn',
        UM: 'United States Minor Outlying Islands',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VU: 'Vanuatu',
        VA: 'Vatikanstadt',
        VE: 'Venezuela',
        AE: 'Vereinigte Arabische Emirate',
        US: ['Vereinigte Staaten von Amerika', 'Vereinigte Staaten', 'USA'],
        GB: ['Vereinigtes Königreich', 'Großbritannien'],
        VN: 'Vietnam',
        WF: 'Wallis und Futuna',
        CX: 'Weihnachtsinsel',
        EH: 'Westsahara',
        CF: 'Zentralafrikanische Republik',
        CY: 'Zypern',
        XK: 'Kosovo',
    },
    en: {
        AF: 'Afghanistan',
        AL: 'Albania',
        DZ: 'Algeria',
        AS: 'American Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua and Barbuda',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BA: 'Bosnia and Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brazil',
        IO: 'British Indian Ocean Territory',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        CV: 'Cape Verde',
        KY: 'Cayman Islands',
        CF: 'Central African Republic',
        TD: 'Chad',
        CL: 'Chile',
        CN: ["People's Republic of China", 'China'],
        CX: 'Christmas Island',
        CC: 'Cocos (Keeling) Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CG: ['Republic of the Congo', 'Congo'],
        CD: ['Democratic Republic of the Congo', 'Congo'],
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        CI: ["Cote d'Ivoire", "Côte d'Ivoire", 'Ivory Coast'],
        HR: 'Croatia',
        CU: 'Cuba',
        CY: 'Cyprus',
        CZ: ['Czech Republic', 'Czechia'],
        DK: 'Denmark',
        DJ: 'Djibouti',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        EC: 'Ecuador',
        EG: 'Egypt',
        SV: 'El Salvador',
        GQ: 'Equatorial Guinea',
        ER: 'Eritrea',
        EE: 'Estonia',
        ET: 'Ethiopia',
        FK: 'Falkland Islands (Malvinas)',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finland',
        FR: 'France',
        GF: 'French Guiana',
        PF: 'French Polynesia',
        TF: 'French Southern Territories',
        GA: 'Gabon',
        GM: ['Republic of The Gambia', 'The Gambia', 'Gambia'],
        GE: 'Georgia',
        DE: 'Germany',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Greece',
        GL: 'Greenland',
        GD: 'Grenada',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard Island and McDonald Islands',
        VA: 'Holy See (Vatican City State)',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungary',
        IS: 'Iceland',
        IN: 'India',
        ID: 'Indonesia',
        IR: ['Islamic Republic of Iran', 'Iran'],
        IQ: 'Iraq',
        IE: 'Ireland',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        JO: 'Jordan',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KP: 'North Korea',
        KR: ['South Korea', 'Korea, Republic of', 'Republic of Korea'],
        KW: 'Kuwait',
        KG: 'Kyrgyzstan',
        LA: "Lao People's Democratic Republic",
        LV: 'Latvia',
        LB: 'Lebanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Marshall Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia, Federated States of',
        MD: 'Moldova, Republic of',
        MC: 'Monaco',
        MN: 'Mongolia',
        MS: 'Montserrat',
        MA: 'Morocco',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NL: ['Netherlands', 'The Netherlands', 'Netherlands (Kingdom of the)'],
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk Island',
        MK: ['The Republic of North Macedonia', 'North Macedonia'],
        MP: 'Northern Mariana Islands',
        NO: 'Norway',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: ['State of Palestine', 'Palestine'],
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippines',
        PN: ['Pitcairn', 'Pitcairn Islands'],
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Qatar',
        RE: 'Reunion',
        RO: 'Romania',
        RU: ['Russian Federation', 'Russia'],
        RW: 'Rwanda',
        SH: 'Saint Helena',
        KN: 'Saint Kitts and Nevis',
        LC: 'Saint Lucia',
        PM: 'Saint Pierre and Miquelon',
        VC: 'Saint Vincent and the Grenadines',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Sao Tome and Principe',
        SA: 'Saudi Arabia',
        SN: 'Senegal',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SK: 'Slovakia',
        SI: 'Slovenia',
        SB: 'Solomon Islands',
        SO: 'Somalia',
        ZA: 'South Africa',
        GS: 'South Georgia and the South Sandwich Islands',
        ES: 'Spain',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard and Jan Mayen',
        SZ: 'Eswatini',
        SE: 'Sweden',
        CH: 'Switzerland',
        SY: 'Syrian Arab Republic',
        TW: ['Taiwan, Province of China', 'Taiwan'],
        TJ: 'Tajikistan',
        TZ: ['United Republic of Tanzania', 'Tanzania'],
        TH: 'Thailand',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad and Tobago',
        TN: 'Tunisia',
        TR: ['Türkiye', 'Turkey'],
        TM: 'Turkmenistan',
        TC: 'Turks and Caicos Islands',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        AE: ['United Arab Emirates', 'UAE'],
        GB: ['United Kingdom', 'UK', 'Great Britain'],
        US: ['United States of America', 'United States', 'USA', 'U.S.A.', 'US', 'U.S.'],
        UM: 'United States Minor Outlying Islands',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietnam',
        VG: 'Virgin Islands, British',
        VI: 'Virgin Islands, U.S.',
        WF: 'Wallis and Futuna',
        EH: 'Western Sahara',
        YE: 'Yemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
        AX: ['Åland Islands', 'Aland Islands'],
        BQ: 'Bonaire, Sint Eustatius and Saba',
        CW: 'Curaçao',
        GG: 'Guernsey',
        IM: 'Isle of Man',
        JE: 'Jersey',
        ME: 'Montenegro',
        BL: 'Saint Barthélemy',
        MF: 'Saint Martin (French part)',
        RS: 'Serbia',
        SX: 'Sint Maarten (Dutch part)',
        SS: 'South Sudan',
        XK: 'Kosovo',
    },
}
